import { getExtremumX, getExtremumY } from "./extremums.js";
import seriesProcessor from "./seriesProcessor.js";
import getColor from "./getColor.js";
import legendGetter from "./legend.js";
import tooltipGetter, { axisTooltipGetter } from "./tooltip.js";
import getSeriesWithDefaultValues from "./getSeriesWithDefaultValues.js";
import tooltipItemPositionGetter from "./tooltipPosition.js";
import keyboardFocusHandler from "./keyboardFocusHandler.js";
import { identifierSerializerSeriesIdDataIndex } from "../../internals/identifierSerializer.js";
export const lineSeriesConfig = {
  colorProcessor: getColor,
  seriesProcessor,
  legendGetter,
  tooltipGetter,
  tooltipItemPositionGetter,
  axisTooltipGetter,
  xExtremumGetter: getExtremumX,
  yExtremumGetter: getExtremumY,
  getSeriesWithDefaultValues,
  keyboardFocusHandler,
  identifierSerializer: identifierSerializerSeriesIdDataIndex
};